import { GraphQLActivationTasksRequester } from '@cobliteam/api-lib';
import { useMutation, useQuery } from '@tanstack/react-query';

const graphQLOnboardingChecklistRequester = new GraphQLActivationTasksRequester();

const useActivationTasks = () => {
  const useGetUserActivationTasks = () =>
    useQuery({
      queryKey: ['userActivationTasks'],
      queryFn: () => graphQLOnboardingChecklistRequester.getUserActivationTasks(),
    });

  const useGetActivationTasks = (categories: string[]) =>
    useQuery({
      queryKey: ['activationTasks'],
      queryFn: () => graphQLOnboardingChecklistRequester.getActivationTasks(categories),
    });

  const useUpdateUserActivationTask = () =>
    useMutation({
      mutationFn: ({ id, finished }: { id: string; finished: boolean }) => graphQLOnboardingChecklistRequester.updateUserActivationTask(id, finished),
    });

  return {
    useGetActivationTasks,
    useGetUserActivationTasks,
    useUpdateUserActivationTask,
  };
};

export default useActivationTasks;
